import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import useListenSize from '../hooks/useListenSize';
import WarningCircle from '../assets/img/warning-circle.svg';
import getLLEsubdomain from '../helpers/getLLEsubdomain';
import { segmentEvent } from '../helpers/sendEvent';

// eslint-disable-next-line no-shadow
function DuePayment() {
  useListenSize();
  const store = useSelector(state => ({
    checkoutLookupData: state.personal?.checkoutLookupData,
    shopify: state.technical?.shopify,
    leaseId: state.personal?.checkoutLookupData?.appId,
  }));

  const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints;
  const isSmallScreen = window.innerWidth <= 768 && window.innerHeight <= 1024;
  const isMobile = isMobileDevice || isTouchDevice || isSmallScreen;
  // eslint-disable-next-line
  console.log(store);
  const leaseId = store.leaseId;

  useEffect(() => {
    segmentEvent('page', 'Past due payment', {
      channel: isMobile ? 'mobile' : 'desktop',
      first_name: store.checkoutLookupData?.checkout_object?.customer?.billing?.first_name,
      last_name: store.checkoutLookupData?.checkout_object?.customer?.billing?.last_name,
    });
  }, []);

  const openWebApp = () => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (userAgent.includes('Android')) {
      window.open('https://play.google.com/store/apps/details?id=com.katapult.katapultapp', '_blank');
    } else {
      window.open('https://apps.apple.com/us/app/katapult-shop-lease-to-own/id1612074883');
    }
  };

  const MakePayment = () => {
    segmentEvent('track', 'Make a payment submitted', {
      channel: isMobile ? 'mobile' : 'desktop',
      first_name: store.checkoutLookupData?.checkout_object?.customer?.billing?.first_name,
      last_name: store.checkoutLookupData?.checkout_object?.customer?.billing?.last_name,
    });
    const redirectUrl = `${window.location.protocol}//${getLLEsubdomain('dot')}katapult.com/app/login?customer`;

    if (isMobile) {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;
      const isIPhone = /iPhone/.test(userAgent);
      const isSafari = /Safari/.test(userAgent) && !/CriOS|FxiOS|OPiOS|EdgiOS/.test(userAgent);
      const deepLink = `katapult://leases/${leaseId}`;

      if (isIPhone && isSafari) {
        window.open(deepLink);
        setTimeout(() => {
          openWebApp();
        }, 5);
      } else {
        const now = new Date().getTime();
        setTimeout(() => {
          if (new Date().getTime() - now < 1500) {
            window.top.location.href = redirectUrl;
          }
        }, 1000);

        const iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.src = deepLink;
        document.body.appendChild(iframe);
      }
    } else {
      window.top.location.href = redirectUrl;
    }
  };

  const goBackToRetailor = () => {
    segmentEvent('track', 'Back to retailer submitted', {
      channel: isMobile ? 'mobile' : 'desktop',
      first_name: store.checkoutLookupData?.checkout_object?.customer?.billing?.first_name,
      last_name: store.checkoutLookupData?.checkout_object?.customer?.billing?.last_name,
    });
    if (window.frameElement || window.self !== window.top) {
      window.parent.postMessage('closeModal', '*');
    } else {
      window.location.href = store.checkoutLookupData?.checkout_object?.urls?.cancel;
    }
  };

  return (
    <div className="k-content-wrapper">
      <section className="k-info">
        <div className="k-error-image-wrapper">
          <img width="150px" height="150px" className="error-icon" src={WarningCircle} alt="" />
        </div>
        <h1>Past Due Balance</h1>
        <p className="due-payment-text">
          You have past due balance with Katapult. Please make a payment and try again.
        </p>
        <div className="k-submit k-error-button">
          <button type="button" onClick={MakePayment}>
            Make a payment
          </button>
        </div>
        <div className="k-submit due-payment-block">
          <button type="button" className="secondary-button due-payment-button" onClick={goBackToRetailor}>
            Back to retailer
          </button>
        </div>
      </section>
    </div>
  );
}

export default DuePayment;
